'use client';

import { createPortal } from 'react-dom';
import { useIsClient } from '../../../headless/useIsClient/useIsClient';
import { AppSpinner } from '../../AppSpinner/AppSpinner';

/**
 * A small spinner in the top-right corner while a write the user keeps
 * working through (an autosave) is in flight. Unlike `Backdrop` it blocks
 * nothing: `pointer-events-none` lets every tap reach the screen beneath.
 *
 * Portalled to the body and `z-60` for the same reasons as `Backdrop`, so it
 * shows above an open dialog.
 */
export function CornerSpinner({ open }: { open: boolean }) {
  const isClient = useIsClient();

  if (!open || !isClient) return undefined;

  return createPortal(
    <div
      role='status'
      aria-label='saving'
      className='pointer-events-none fixed top-3 right-3 z-60 rounded-full bg-background p-2 shadow-md'
    >
      <AppSpinner size='sm' className='text-primary' />
    </div>,
    document.body,
  );
}
